<div class="app">
    <app-tracking></app-tracking>
</div>